import styled from 'styled-components';

export const CardButton = styled.div`
    /* margin-top: 10px; */
    /* text-align: end; */
    
    button { 
        background-color: transparent;
        border: 0px;
    }
`;